import scrollEvent from '../fsUtils/scrollEvent';
import Viewports from "../fsUtils/Viewports";
/*
    "PageSkinPin"
    Purpose:
        to enable creative/page background skin pinning when scrolling 
        for WP posts and pages that has the "Page Skin" meta box.
    NOTE:
        * "Page Skin" is different from skin ads, as the former is added from the WP Admin, 
        while the latter is driven by the ad engine.
        * this class has to be very light.
*/

class PageSkinPin {

    constructor() {
        // elements and classnames
        this.bodyClassList = document.body.classList;
        this.bodyHeader = document.getElementById('js-body-header');
        this.secNav = document.querySelector('.section-nav');
        // objects and values
        this.viewports = new Viewports();
        this.lastScrollTop = 0;
        this.hasSkin = this.hasPageSkin();

        if (this.hasSkin) {
            // add scroll event only when page skin is detected
            let toggleScrollEvent = scrollEvent.throttle(this.togglePageSkinPosOnScroll.bind(this),10);

            window.addEventListener("scroll", toggleScrollEvent);

            this.togglePageSkinPosOnScroll();
        }
    }
    // get pin position based on the global and secondary navigation's structure
    getPinPosition() {
        // check for secondary nav
        if (this.secNav) {
            // check for secondary nav type
            if (this.bodyClassList.contains('contains-team-display-menu') || this.bodyClassList.contains('secondary-tall')) {
                return this.bodyHeader.offsetHeight + this.secNav.offsetHeight;
            } else {
                return this.secNav.offsetHeight;
            }
        }
        // if there's no secondary nav (homepage, etc.)
        return 0;
    }
    // check for the page skin classname added by a PHP function
    hasPageSkin() {
        return this.bodyClassList.contains('has-skin');
    }
    // toggle page skin pinning condition
    togglePageSkinPosOnScroll() {

        if (this.viewports.getViewPort() === 'desktop') {
            // get scroll position
            let scrollYpos = window.pageYOffset || document.documentElement.scrollTop;
            if (this.hasSkin) {
                // get pin position
                this.pinPos = this.pinPos || this.getPinPosition();

                if (scrollYpos >= this.pinPos) {
                    // pin when scroll position is beyond the pin position
                    this.bodyClassList.add('pageSkinPin');
                } else if (scrollYpos < this.pinPos) {
                    // remove when scroll position is before the pin position
                    this.bodyClassList.remove('pageSkinPin');
                }
            }

            this.lastScrollTop = scrollYpos;
        }
    }
}
// instantiate on import/page load
export default new PageSkinPin();


// WEBPACK FOOTER //
// ./assets/components/fsUtils/pageSkinPin.js